import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => {
  return {
    path: "student-profile/:type/:id",
    component: withAsyncRouteLoading(() =>
      Promise.all([
        import(/* webpackChunkName: "global-student-profile" */ "./components"),
      ]).then(([importedModule]) => {
        const component = importedModule.default;
        return component;
      })
    ),
  };
};
